import type { VideoState } from './types';
import noop from 'lodash/noop';
import { PlayStates, VisibilityStates } from '../pop-out-media-manager/types';

export const initialVideoState: VideoState = {
  popOutState: {
    visibilityState: VisibilityStates.Hidden,
    id: null,
  },
  activeVideoState: {
    id: null,
    playState: 'NoPlayer',
  },
};

export const defaultContextValue = {
  addInlinePlayer: noop,
  setNoActiveVideo: noop,
  popVideo: noop,
  unPopVideo: noop,
  removeInlinePlayer: noop,
  isPopped: () => false,
  isPaused: () => true,
  popOutState: () => initialVideoState.popOutState,
  inlinePlayerVisibilityState: () => null,
  popOutVisibilityState: VisibilityStates.Hidden,
  dismiss: noop,
  getCurrentlyActive: () => ({
    id: null,
    playState: PlayStates.NoPlayer,
  }),
  pauseVideo: noop,
} as const;

export const seekShortcutDeltaSecs = 1;
